module.exports = __webpack_public_path__ + "media/Ring.8e2462dc.mp3";